import React from "react";
import Header from "./Header";
import CircleRateCalculator from "./CircleRateCalculator";
import CircleRateQA from "./CircleRateQA";
import ListOfOtherSer from "./ListOfOtherSer";
import ChatBot from "./chatBot/ChatBot";

const Body = () => {
  return (
    <div>
      <Header />
      <CircleRateCalculator />
      <CircleRateQA />
      <ListOfOtherSer />
      <ChatBot />
    </div>
  );
};

export default Body;
